export default {
  "shoes": "Chaussures",
  "hoodies": "Hoodies/Sweats",
  "tshirts": "T-shirts",
  "jackets": "Vestes",
  "pants": "Pantalons/Shorts",
  "headwear": "Couvre-chefs",
  "sets": "Ensembles",
  "underwear": "Sous-vêtements",
  "jersey": "Maillots",
  "accessories": "Accessoires",
  "bags": "Sacs",
  "belts": "Ceintures",
  "perfumes": "Parfums",
  "other": "Autres articles",
  "view": "Voir",
  "tag.shoes": "Chaussures",
  "tag.hoodies": "Hauts",
  "tag.tshirts": "Hauts",
  "tag.jackets": "Vestes",
  "tag.pants": "Bas",
  "tag.headwear": "Accessoires",
  "tag.sets": "Ensembles",
  "tag.underwear": "Sous-vêtements",
  "tag.jersey": "Sport",
  "tag.accessories": "Extras",
  "tag.bags": "Sacs",
  "tag.belts": "Accessoires",
  "tag.perfumes": "Parfums",
  "tag.other": "Plus"
};